import React, { useContext } from 'react'
import { View } from 'oio-react'
import PropTypes from 'prop-types'
import ProtoThemeContext from 'src/libraries/contexts/ProtoTheme'

const LayoutContainerFixedArea = ({ children }) => {
   const { protoTheme: theme } = useContext(ProtoThemeContext)

   return (
      <View
         position="relative"
         width="100%"
         height={theme.tmpContentFixedAreaHeight}
         style={{ overflow: 'hidden' }}>
         {children}
      </View>
   )
}

LayoutContainerFixedArea.propTypes = {
   children: PropTypes.node.isRequired
}

export default LayoutContainerFixedArea
